export interface ClientFilterType {
  clients: server.dto.ClientSmall[];
}

export const getSortedClientNames = (filter: ClientFilterType) => {
  return filter.clients.map(c => c.name).sort();
}

export const initialClientFilter: ClientFilterType = {
  clients: []
};
